import React, { useCallback } from 'react';
import type { Snippet } from '../snippetTypes.ts';
import { SnippetPanelItem } from './SnippetPanelItem.tsx';

import { Stack } from '@atlaskit/primitives/compiled';

export const SnippetPanelList = ({ snippets }: { snippets: Snippet[] }) => {
	const onClick = useCallback(() => {}, []);
	return (
		<Stack>
			{snippets?.map((snippet) => (
				<SnippetPanelItem key={snippet.snippetId} snippet={snippet} onClick={onClick} />
			))}
		</Stack>
	);
};
